import { makeStyles } from '@material-ui/core';
import { em, vh, vw } from '../../common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(() => ({
  wrapper: {
    backgroundColor: themeColor.lightBackground,
    flexDirection: 'column',
  },

  header: {
    padding: 10,
  },

  content: {
    padding: 10,
    fontSize: em(16),
    flex: 1,
  },

  main: {
    flexDirection: 'column',
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },

  message: {
    flexDirection: 'column',
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  iconLabel: {
    width: vw(2.85),
    height: vh(4.16),
    marginTop: vh(0.65),
  },

  keypad: {
    display: 'flex',
    alignItems: 'end',
  },

  cancelButton: {
    fontSize: vh(2.1248),
    marginRight: vh(1.328),
  },
}));

export const electronicTitleStyles = makeStyles(theme => ({
  electronicTitleContainer: {
    height: vh(8.8),
  },
  electronicTitleBar: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `${vw(0.5)} solid ${theme.palette.secondary.main}`,
  },
  electronicTitleHeader: {
    color: themeColor.modalTitle,
  },
  electronicTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  electronicTitleWeightLabel: {
    fontSize: vh(3.187250996015936),
    fontWeight: 500,
  },
  electronicTitleWeightContainer: {
    width: 'fit-content',
    height: 'fit-content',
    alignSelf: 'flex-end',
  },
  selectDepartmentSubheading: {
    fontWeight: 500,
    lineHeight: vh(2.65),
    fontSize: vh(2.39),
  },
}));
